import { connect } from 'react-redux';
import { actions as coreActions, selectors as coreSelectors } from 'app-webtech-core';
import { WAM_D0_ALREADY_DISMISSED as ALREADY_DISMISSED } from 'app-modules/base/feature-discovery';
import { showAuthenticationDialog } from 'app-modules/ui/actions';
import * as selectors from '../selectors';
import * as actions from '../actions';
import { OnboardDialogComponent } from '../components/OnboardDialog';
import { wamEpisodeStartsOn } from '../utils/wamEpisodeStartsOn';

const mapStateToProps = (state) => {
  const wamEpisodeStartsOnDate = wamEpisodeStartsOn(state);
  return {
    wamEpisodeStartsOnDate,
    isVisible: selectors.showOnboardDialog(state),
    isAuthenticated: coreSelectors.userAccount.isAuthenticated(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(actions.hideOnboardDialog()),
  showSignUp: () => dispatch(showAuthenticationDialog()),
  dialogDismissed: () => dispatch(coreActions.application.featureDiscovered(ALREADY_DISMISSED)),
});

export const OnboardDialog = connect(mapStateToProps, mapDispatchToProps)(OnboardDialogComponent);
